import type { JSX } from 'react'

import { AuthFormBoxRowGaps } from "/app/libraries/arcana/src/blocks/AuthFormBox/index.ts"
import { AuthFormBoxTemplate } from "/app/libraries/arcana/src/blocks/AuthFormBox/Templates/index.ts"
import { TextBlock, TextBlockDirection, TextBlockRowGap } from "/app/libraries/arcana/src/blocks/TextBlock/index.ts"
import { TextBoxMaxLine1Headline2 } from "/app/libraries/arcana/src/atoms/TextBox/Templates/index.ts"

import { useUnit } from 'effector-react'
import { AuthTabs } from '~/features/change-auth-type'
import { model as forgotPasswordFeature } from '~/features/subscriber/forgot-password'
import {
  SignInByEmailForm,
  SignInByPhoneForm,
  model as signInFeatureModel,
} from '~/features/subscriber/sign-in'
import { model as signUpFeatureModel } from '~/features/subscriber/sign-up'
import { useErrorMessage } from '~/widgets/Popups/MessagePortal'
import { $signInFormTranslations } from './i18n'
import { $isSignInByEmailActivated, $isSignInByPhoneActivated } from './model'
import { SignUpLink } from './SignUpLink'

export const SignInForm = (): JSX.Element => {
  const formTranslations = useUnit($signInFormTranslations)
  const message = useUnit(signInFeatureModel.$message)
  const signUpEnabled = useUnit(signUpFeatureModel.$enabled)
  const signUpExternalDomain = useUnit(signUpFeatureModel.$link)
  const forgotPasswordEnabled = useUnit(
    forgotPasswordFeature.$resetPasswordEnabled
  )
  const sighUpRedirectLink = signUpExternalDomain || '/sign-up'

  const isPhoneRegistration = useUnit($isSignInByPhoneActivated)
  const isEmailRegistration = useUnit($isSignInByEmailActivated)

  const signInWithPhoneEnabled = useUnit(
    signInFeatureModel.$signInWithPhoneEnabled
  )

  const rowGap = signInWithPhoneEnabled
    ? AuthFormBoxRowGaps.SIZE_160
    : AuthFormBoxRowGaps.SIZE_150

  useErrorMessage(message, 'SignInForm')

  return (
    <AuthFormBoxTemplate rowGap={rowGap}>
      <TextBoxMaxLine1Headline2 title={formTranslations.title} />
      {signInWithPhoneEnabled && <AuthTabs />}
      {isPhoneRegistration && <SignInByPhoneForm />}
      {isEmailRegistration && (
        <SignInByEmailForm
          forgotPasswordEnabled={forgotPasswordEnabled}
          rowGap={AuthFormBoxRowGaps.SIZE_170}
        />
      )}

      <TextBlock
        direction={TextBlockDirection.ROW}
        rowGap={TextBlockRowGap.INDENT_20}
      >
        {signUpEnabled && (
          <SignUpLink sighUpRedirectLink={sighUpRedirectLink} />
        )}
      </TextBlock>
    </AuthFormBoxTemplate>
  )
}
